import React from "react";

import async from "./components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
//import DashboardLayout from "./layouts/Dashboard";

// Guards
import AuthGuard from "./components/guards/AuthGuard";
import SignIn from "./pages/Public/SignIn";
import ForgotPass from "./pages/Public/ForgotPass";
import SignUp from "./pages/Public/SignUp";
import DashboardComponent from "./pages/Private/Dashboard";

// Auth components

// Dashboard components
import Campanha from "./pages/Private/Campaign";
import Deeplink from "./pages/Public/Deeplink/group";
import Projetos from "./pages/Private/Projetos";
import Contas from "./pages/Private/Contas";
import Operacoes from "./pages/Private/Operacoes";
import Disparo from "./pages/Private/Disparo";
import Adicionaroperacao from "./pages/Private/Adicionaroperacao";

import Editarconta from "./pages/Private/Contas/Editarconta/index";
import Qrcode from "./pages/Private/Qrcode";
import Analisedash from "./pages/Private/Analisedash";

import Blacklist from "./pages/Private/Blacklist";
import Editarperfil from "./pages/Private/Editarperfil";
import Broadcasts from "./pages/Private/Broadcasts";
import Leadscoring from "./pages/Private/Leadscoring";
import Calendario from "./pages/Private/Calendario";

//Rotas do menu de adicionar operações


import Automacoeswp from "./pages/Private/Automacoeswp";
import Adicionarauto from "./pages/Private/Adicionarauto";

import Mudanome from "./pages/Private/Mudanome";
import Mudadescricao from "./pages/Private/Mudadescricao";
import Mudaimagem from "./pages/Private/Mudaimagem";
import Mudaconfig from "./pages/Private/Mudaconfig";
import Entrarnogrupo from "./pages/Private/Entrarnogrupo";
import Adicionaradm from "./pages/Private/Adicionaradm";
import Removeradm from "./pages/Private/Removeradm";
import Removerparticipante from "./pages/Private/Removerparticipante";
import Movergrupos from "./pages/Private/Movergrupos";
import { element } from "prop-types";
import Dashcampanha from "./pages/Private/Campaign/Show";
import LinkedZapCampaign from "./pages/Private/Campaign/Show/LinkedZap";
import Grupos from "./pages/Private/Campaign/Show/Grupos";
import DeeplinkGroup from "./pages/Public/Deeplink/group";
import DeeplinkCampaign from "./pages/Public/Deeplink/campaign";
import WhatsAppActComponentShow from "./pages/Public/WhatsAppPublic/index";
import AuthCheckToken from "./components/guards/AuthCheckToken";
import CampaignOperations from "./pages/Private/Campaign/Show/Operacoes";
import CampaignAddOperations from "./pages/Private/Campaign/Show/Operacoes/Adicionaroperacao";
import ViewBroadcast from "./pages/Private/Broadcasts/view/Broadcast";
import SendMessageBroadCast from "./pages/Private/Broadcasts/view/operation/SendMessageBroadCast";

const routes = [
  {
    path: "/public/whatsapp/:id",
    element: <React.Fragment />,
    element: <WhatsAppActComponentShow />,
  },

  {
    path: "/",
    element: <AuthCheckToken />,
    children: [
      {
        path: "",
        element: <SignIn />,
      },
      {
        path: "sign-in/",
        element: <SignIn />,
      },
      {
        path: "forgot-password",
        element: <ForgotPass />,
      },
      {
        path: "sign-up/",
        element: <SignUp />,
      },


      {
        path: "deeplink/group/:hashLinkId",
        element: <DeeplinkGroup />,
      },
      {
        path: "deeplink/campaign/:hashLinkId",
        element: <DeeplinkCampaign />,
      },

      {
        path: "contas",
        element: <AuthGuard />,
        children: [
          {
            path: "",
            element: <Contas />,
          },
          {
            path: ":id",
            element: <Editarconta />,
          }
        ],
      },

      {
        path: "projetos",
        element: <Projetos />,
      },
      {
        path: "operacoes",
        element: <Operacoes />,
      },
      {
        path: "disparo",
        element: <Disparo />,
      },
      {
        path: "dashcampanha/:campanhaid",
        element: <Dashcampanha />,
      },
      {
        path: "adicionaroperacao",
        element: <Adicionaroperacao />,
      },

      {
        path: "mudanome",
        element: <Mudanome />,

      },
      {
        path: "mudadescricao",
        element: <Mudadescricao />,
      },
      {
        path: "mudaimagem",
        element: <Mudaimagem />,
      },
      {
        path: "mudaconfig",
        element: <Mudaconfig />,
      },
      {
        path: "entrarnogrupo",
        element: <Entrarnogrupo />,
      },
      {
        path: "adicionaradm",
        element: <Adicionaradm />,
      },
      {
        path: "removeradm",
        element: <Removeradm />,
      },
      {
        path: "removerparticipante",
        element: <Removerparticipante />,
      },
      {
        path: "movergrupos",
        element: <Movergrupos />,
      },
      {
        path: "automacoeswp",
        element: <Automacoeswp />,
      },



      {
        path: "qrcode",
        element: <Qrcode />,
      },
      {
        path: "analisedash",
        element: <Analisedash />,

      },



      {
        path: "adicionarauto",
        element: <Adicionarauto />,

      },

      {
        path: "deeplink",
        element: <Deeplink />,
      },

      {
        path: "blacklist",
        element: <Blacklist />,
      },
      {
        path: "blacklist/:id",
        element: <Blacklist />,
      },

      {
        path: "editarperfil",
        element: <Editarperfil />,
      },




      {
        path: "leadscoring",
        element: <Leadscoring />,
      },

      {
        path: "calendario",
        element: <Calendario />,
      },



    ],
  },

  {
    path: "broadcast",
    element: <AuthGuard />,
    children: [
      {
        path: "",
        element: <Broadcasts />,
      },
      {
        path: ":id",
        element: <ViewBroadcast />,
      },
      {
        path: ":id/:operation?",
        element: <ViewBroadcast />,
      },
      {
        path: ":id/criar/message",
        element: <SendMessageBroadCast />,
      },
    ],
  },
  {
    path: "app",
    element: <AuthGuard />,
    children: [
      {
        path: "",
        element: <DashboardComponent />,
      },
    ],
  },

  {
    path: "campanha",
    element: <AuthGuard />,
    children: [

      {
        path: "",
        element: <Campanha />,
      },
      {
        path: ":id",
        element: <Dashcampanha />,
      },

      {
        path: ":id/contas-vinculadas",
        element: <LinkedZapCampaign />,
      },

      {
        path: ":id/grupos",
        element: <Grupos />,
      },
      {
        path: ":id/analisedash",
        element: <Analisedash />,
      },
      {
        path: ":id/operacoes",
        element: <CampaignOperations />,
      },
      {
        path: ":id/operacoes/add",
        element: <CampaignAddOperations />,
      },
    ],
  }
];

export default routes;
